import { StepperHeaderProps } from '@/components/generic/Stepper/types';
import { SubmitOrderModalConfig } from '@/store/reducers/global/types';
import {
  ContactVm,
  CreateDesignToOrderVm,
  CreateOrderItemVm,
  OpportunityVm,
  PriceBookEntryVm,
  ProposalItemVm,
  ProposalVm,
  SolarProductType,
  WatcherVm,
} from '@/types';
import { AdderVm } from '@/types/backend/models/Adder';

import { SelectedServices } from './components/OrderDetailsStep/components/SelectServices/types';

export type Props = {
  allPriceBookEntries: PriceBookEntryVm[];
  allShippingAddresses: ContactVm[];
  homeownerAddress: ContactVm | null;
  loadingModalDataInProgress: boolean;
  modalConfig: SubmitOrderModalConfig;
  opportunity: OpportunityVm | null;
  productLineName: ProductLineName | null;
  proposal: ProposalVm | null;
  proposalItems: ProposalItemVm[];
  clearCalculatedTax(): void;
  clearCreatedOrderId(): void;
  clearOpportunity(): void;
  closeSubmitOrderModal(): void;
  fetchDesignToOrderProducts(opportunityId: string): void;
  fetchOpportunity(id: string): void;
  fetchProposalItems(proposalId: string): void;
  fetchShippingAddresses(): void;
};

// TODO: Specify the name of this State to be more descriptive
export type State = {
  wizardHeaderSteps: StepperHeaderProps['steps'];
  visibleOrderItems: OrderItemWrapper[];
  hiddenOrderItems: OrderItemWrapper[];
  isRidgeCapSectionEnabled: boolean;
  isAsphaltShingleSectionEnabled: boolean;
  order: Omit<CreateDesignToOrderVm, 'partialReRoof'> & {
    partialReRoof: boolean | null;
    distributionWarranty: string | null;
    watcherList: WatcherVm[];
    solarOnly: boolean | null;
  };
  prevShippingAddressesLength: number;
  prevProposalItemsLength: number;
  isCancellationModalOpened: boolean;
  selectedServices: SelectedServices;
  esShingleQuantity: number;
  quantity: number;
  isPriceHidden: boolean;
  isAccessProgram: boolean;
  isDistribution?: boolean;
  adders?: AdderVm[];
  proposalSolarProductType: SolarProductType;
};

export type OrderDetail = State;

export enum StepsName {
  Eligibility = 'Eligibility',
  'Order Details' = 'Order Details',
  'Contract Details' = 'Contract Details',
  Products = 'Products',
  Services = 'Services',
  Shipping = 'Shipping',
  Confirmation = 'Confirmation',
  'Request Contract' = 'Request Contract',
  Success = 'Success',
}

export type ProductLineName = 'Decotech®' | 'Timberline Solar™';

export type OrderItemWrapper = {
  priceBookEntry: PriceBookEntryVm;
  orderItem: CreateOrderItemVm;
  // order item added for timberline solar orders may not have corresponding
  // proposal items if those items were not initially added to proposal via Salesforce
  proposalItem: ProposalItemVm | null;
};

export type TaxableItem = {
  SKU: string;
  price: number;
  commodityCode: string | null;
};

export interface OrderEditorProps {
  order?: OrderDetail;

  onOrderChange?: (order: OrderDetail) => void;
}
